import React, { ChangeEvent, EventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.css';

interface IProps {
	value: string;
	handleChange: EventHandler<ChangeEvent>;
	handleSearch: () => void;
}
export const SearchInput = ({ value, handleChange, handleSearch }: IProps) => {
	const { t } = useTranslation('translation');
	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			handleSearch();
		}

		return;
	};

	return (
		<div className={styles.input_wrapper}>
			<input
				type="text"
				value={value}
				onKeyDown={handleKeyDown}
				onBlur={handleSearch}
				onChange={handleChange}
				className={styles.input}
				placeholder={t('Поиск')}
			/>
			<button onClick={handleSearch} className={styles.search_icon}>
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M14 14L10.0001 10M11.3333 6.66667C11.3333 9.244 9.244 11.3333 6.66667 11.3333C4.08934 11.3333 2 9.244 2 6.66667C2 4.08934 4.08934 2 6.66667 2C9.244 2 11.3333 4.08934 11.3333 6.66667Z" stroke="#9DA4AE" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
			</button>
		</div>
	);
};
